module.exports = __webpack_public_path__ + "img/messages-blue.f4ddd743.png";